/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_Resolve_ErrorInputs */

const vi_vehicle_gps_resolve_error = /** @type {(inputs: Vehicle_Gps_Resolve_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể kết nối IMEI với VnetGPS`)
};

/**

* @param {Vehicle_Gps_Resolve_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_resolve_error = /** @type {((inputs?: Vehicle_Gps_Resolve_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_Resolve_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_resolve_error(inputs)
});